module.exports = __webpack_public_path__ + "img/welcome-kids-mode.cc697466.png";